// extracted by mini-css-extract-plugin
module.exports = {"root":"LowestPrice_root__20AvB","rootPrice":"LowestPrice_rootPrice__fW___","rootDescription":"LowestPrice_rootDescription__k0p76"};